<template lang="">
  <div class="data-protection-statement">
    <div class="all">
      <main v-if="language == 'en'">
        <div class="container-box container-box--no-border">
          <div class="container-box__inner">
            <div class="row">
              <div
                class="col-tn-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 bab-stripe"
              >
                <div>
                  <div
                    class="standard-content"
                    data-wt-contenttype="HKStandardText"
                    data-wt-view="simple"
                  >
                    <div>
                      <div class="extendedRichtext">
                        <h1>Data Protection Statement</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-box container-box--no-border">
          <div class="container-box__inner">
            <h2 class="row-headline row-headline--with-border">
              <span>General</span>
            </h2>
            <div class="row">
              <div
                class="col-tn-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 bab-stripe"
              >
                <div
                  class="standard-content"
                  data-wt-contenttype="HKStandardText"
                  data-wt-view="simple"
                >
                  <div>
                    <div class="extendedRichtext">
                      <div>
                        <div class="text">
                          <p>
                            Henkel (China) Investment Co., Ltd., hereinafter
                            referred to as Henkel, respects the privacy of each
                            person who visits our website. Now we would like to
                            inform you of the type of data collected by Henkel
                            and how they are used. You will also learn how you
                            can exercise your data subjects’ rights.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            Any changes to this Data Protection Statement will
                            be published on this page. This enables you to
                            inform yourself at any time about which data we are
                            collecting and how we use such data.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            This Data Protection Statement does not apply to
                            websites accessible via hyperlinks on Henkel
                            websites.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-box container-box--no-border">
          <div class="container-box__inner">
            <h2 class="row-headline row-headline--with-border">
              <span>Collection, use and processing of personal data</span>
            </h2>
            <div class="row">
              <div
                class="col-tn-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 bab-stripe"
              >
                <div
                  class="standard-content"
                  data-wt-contenttype="HKStandardText"
                  data-wt-view="simple"
                >
                  <div>
                    <div class="extendedRichtext">
                      <div>
                        <div class="text">
                          <p>
                            Name of the responsible entity: Henkel (China)
                            Investment Co., Ltd.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            Address of the responsible entity: No. 99
                            Jiangwancheng Road, Yangpu District, Shanghai,
                            Building 7, Shangpu Center, 200438,
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            Henkel uses personal data primarily to provide this
                            website to the users. Any further processing of the
                            data only occurs on the basis of other statutory
                            duties or permissions or if the respective user has
                            consented towards Henkel.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            Henkel stores and processes data specifically for
                            the following purposes:
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            When users visit the website, Henkel automatically
                            collects and stores certain data. This includes: the
                            IP address or device ID allocated to the respective
                            end-device which we need for transmitting requested
                            content (e.g. especially content, texts, images, and
                            product information as well as data files provided
                            for downloading, etc.), the activity of users in the
                            context of the website, the type of respective
                            end-device, the used type of browser as well as the
                            date and time of use.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            Henkel stores this information for a maximum of 7
                            days for the purpose of recognizing and pursuing
                            misuse.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            Henkel uses this information also for improvements
                            to the service’s presentation, features and
                            functionalities as well as general administration
                            tasks.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            Aside from this, Henkel deletes or anonymizes the
                            data on use, including the IP addresses, without
                            undue delay as soon as they are no longer needed for
                            the above mentioned purposes.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            The processing and use of the data is based on
                            statutory provisions which justify those operations
                            on the grounds that (1) the processing is necessary
                            for the provision of the website; or (2) Henkel has
                            an overriding legitimate interest in ensuring and
                            enhancing the functionality and error-free operation
                            of the website and that it is tailored to the users’
                            needs.
                          </p>
                        </div>
                        <div class="text"><p></p></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-box container-box--no-border">
          <div class="container-box__inner">
            <h2 class="row-headline row-headline--with-border">
              <span>Further Personal Data Processing</span>
            </h2>
            <div class="row">
              <div
                class="col-tn-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 bab-stripe"
              >
                <div
                  class="standard-content"
                  data-wt-contenttype="HKStandardText"
                  data-wt-view="simple"
                >
                  <div>
                    <div class="extendedRichtext">
                      <div>
                        <div class="text">
                          <p><strong>Consumer request table</strong></p>
                        </div>
                        <div class="text">
                          <p>
                            You may have provided your contact data via our
                            contact form.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            We will use your data for the purpose of replying to
                            your request.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            The processing and use of your data is based on
                            statutory provisions which justify those operations
                            on the grounds that the processing is necessary for
                            processing your request.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            If you have not given consent to a longer storage
                            duration e.g. in the course of our customer
                            relationship management we will store the data no
                            longer than needed in order to fulfill the
                            aforementioned purpose or as long as required in
                            case any statutory retention obligation applies.
                          </p>
                        </div>
                      </div>
                      <div>
                        <div class="text">
                          <p><strong>Raffles</strong></p>
                        </div>
                        <div class="text">
                          <p>
                            You may have provided your contact data and your
                            address while participating in a raffle which we
                            offer from time to time on our website. We will use
                            your data for the purpose of conducting the raffle.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            We will not forward your data to any third party
                            unless for the distribution of prizes or for
                            conducting the raffle.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            The processing and use of your data is based on
                            statutory provisions which justify those operations
                            on the grounds that the processing is necessary for
                            conducting the raffle.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            If you have not given consent to a longer storage
                            duration e.g. in the course of our customer
                            relationship management we will store the data no
                            longer than needed in order to fulfill the
                            aforementioned purpose or as long as required in
                            case any statutory retention obligation applies.
                          </p>
                        </div>
                      </div>
                      <div>
                        <div class="text">
                          <p><strong>Product test</strong></p>
                        </div>
                        <div class="text">
                          <p>
                            You may have provided your contact data and your
                            address while participating in product tests. We
                            will use your data for the purpose of conducting the
                            product test.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            We will not forward your data to any third party
                            unless for the purpose of conducting the product
                            test.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            The processing and use of your data is based on
                            statutory provisions which justify those operations
                            on the grounds that the processing is necessary for
                            carrying out the product test.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            If you have not given consent to a longer storage
                            duration e.g. in the course of our customer
                            relationship management we will store the data no
                            longer than needed in order to fulfill the
                            aforementioned purpose or as long as required in
                            case any statutory retention obligation applies.
                          </p>
                        </div>
                      </div>
                      <div>
                        <div class="text">
                          <p><strong>Webinar</strong></p>
                        </div>
                        <div class="text">
                          <p>
                            You may have provided your contact data, e.g your
                            email address while participating in webinars. We
                            will use your data for the purpose of providing the
                            webinar.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            We will not forward your data to any third party
                            unless for the purpose of conducting the webinar.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            The processing and use of your data is based on
                            statutory provisions which justify those operations
                            on the grounds that the processing is necessary for
                            providing the webinar to you.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            If you have not given consent to a longer storage
                            duration e.g. in the course of our customer
                            relationship management we will store the data no
                            longer than needed in order to fulfill the
                            aforementioned purpose or as long as required in
                            case any statutory retention obligation applies.
                          </p>
                        </div>
                      </div>
                      <div>
                        <div class="text">
                          <p><strong>Surveys</strong></p>
                        </div>
                        <div class="text">
                          <p>
                            You may have provided your contact data, e.g your
                            email address while participating in a survey. We
                            will use your data for the purpose of conducting the
                            survey.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            We will not forward your data to any third party
                            unless for the purpose of conducting the survey.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            The processing and use of your data is based on
                            statutory provisions which justify those operations
                            on the grounds that the processing is necessary for
                            conducting the survey.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            If you have not given consent to a longer storage
                            duration e.g. in the course of our customer
                            relationship management we will store the data no
                            longer than needed in order to fulfill the
                            aforementioned purpose or as long as required in
                            case any statutory retention obligation applies.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-box container-box--no-border">
          <div class="container-box__inner">
            <h2 class="row-headline row-headline--with-border">
              <span>Consent / Withdrawal of Consent</span>
            </h2>
            <div class="row">
              <div
                class="col-tn-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 bab-stripe"
              >
                <div
                  class="standard-content"
                  data-wt-contenttype="HKStandardText"
                  data-wt-view="simple"
                >
                  <div>
                    <div class="extendedRichtext">
                      <div>
                        <div class="text">
                          <p>
                            <strong
                              >Customer Relationship &amp; Online Communities
                              Management</strong
                            >
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            You may have given consent that Henkel processes
                            your contact data which you may have provided to
                            Henkel, the content and circumstances of your
                            electronic communication with Henkel such as contact
                            forms or e-mail, your usage of Henkel websites, data
                            on your participation in Henkel’s online trainings,
                            activities on Henkel’s Social Media sites (in Blogs,
                            Facebook Fanpages etc.) for the purposes of
                            advertising (by post, in browser, in app and as
                            specified below if you provide an additional
                            consent), rendering technical advice such as usage
                            of products or technologies, market research, and
                            providing online services such as eLearning,
                            webinars communication in relation to events,
                            conducting surveys. To achieve the selected purposes
                            Henkel may combine the above listed data with other
                            data Henkel may have legally collected about you for
                            instance from raffles or other website activities,
                            and analyze the data in order to determine relevant
                            advertising measures.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            In the course of this analysis Henkel applies an
                            automated methodology that helps prioritize leads
                            for sales. Contacts are categorized according to
                            their online and off-line activities. Based on the
                            category they are assigned to and the location they
                            are the contacts are assigned to sales persons and
                            receive different information on our products and
                            services as well as advertising material.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            You may have given consent that Henkel may forward
                            your personal data to a 3rd Party agency for the
                            following purpose:
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            Your data might be forwarded to the distributor who
                            is responsible for the respective region and product
                            category.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            We will store the data only as long as the consent
                            is valid or as long as required in case of any
                            statutory retention obligations.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            You may withdraw your consent with effect for the
                            future at any time by clicking the respective
                            consent withdrawal hyperlink or by sending a letter
                            or an e-mail to our data protection officer Mr.
                            Frank Liebich, Henkelstrasse 67, D 40191 Düsseldorf,
                            Germany (E-Mail: Datenschutz@henkel.com). The
                            withdrawal of consent will not affect the lawfulness
                            of processing based on consent before its
                            withdrawal.
                          </p>
                        </div>
                      </div>
                      <div>
                        <div class="text">
                          <p><strong>Electronic Mail Advertising</strong></p>
                        </div>
                        <div class="text">
                          <p>
                            You may further have declared your consent that
                            Henkel may contact you regarding offers, products
                            and services regarding products from Henkel’s
                            Adhesive Technologies range via electronic mail
                            (e-mail, sms, mms, instant message) and/or
                            telephone.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            We will use your data as set forth above under
                            section Further Personal Data Processing of this
                            Data Protection Statement to provide you with
                            respective advertising measures.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            You may withdraw your consent with effect for the
                            future at any time by clicking the respective
                            consent withdrawal hyperlink or by sending a letter
                            or an e-mail to our data protection officer Mr.
                            Frank Liebich, Henkelstrasse 67, D 40191 Düsseldorf,
                            Germany (E-Mail: Datenschutz@henkel.com). The
                            withdrawal of consent will not affect the lawfulness
                            of processing based on consent before its
                            withdrawal.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-box container-box--no-border">
          <div class="container-box__inner">
            <h2 class="row-headline row-headline--with-border">
              <span>Cookies, Pixel, Fingerprints</span>
            </h2>
            <div class="row">
              <div
                class="col-tn-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 multiple-elements-in-col bab-stripe"
              >
                <div
                  class="standard-content"
                  data-wt-contenttype="HKStandardText"
                  data-wt-view="simple"
                >
                  <div>
                    <div class="extendedRichtext">
                      <div>
                        <div class="text">
                          <p>
                            This website uses cookies and similar technologies.
                            Technically necessary cookies will be used
                            automatically. Other cookies (or similar
                            technologies) will only be applied based on your
                            prior consent. You can find more information on the
                            Cookies used by our website and their purposes in
                            our Cookie Policy. There, you will also find
                            information on how to withdraw your consent for the
                            future.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            Your preference is set for the named domain, per
                            browser and computer. Therefore, if you visit our
                            website at home and work or with different browsers,
                            you need to refuse data storage with every device or
                            browser.
                          </p>
                        </div>
                        <div class="text"><p></p></div>
                        <div class="text"><p></p></div>
                        <div class="text">
                          <p>
                            <a
                              class="hk-internal-link"
                              href="https://www.henkel.cn/cookies"
                              target="_self"
                              data-webtrekkactionname="defaultLink"
                            ></a
                            ><a
                              class="hk-internal-link"
                              href="https://www.henkel.cn/cookies"
                              target="_self"
                              data-webtrekkactionname="defaultLink"
                            ></a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-box container-box--no-border">
          <div class="container-box__inner">
            <h2 class="row-headline row-headline--with-border">
              <span>Web Tracking</span>
            </h2>
            <div class="row">
              <div
                class="col-tn-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 bab-stripe"
              >
                <div
                  class="standard-content"
                  data-wt-contenttype="HKStandardText"
                  data-wt-view="simple"
                >
                  <div>
                    <div class="extendedRichtext">
                      <div>
                        <div class="text">
                          <p><strong>Google Analytics</strong></p>
                        </div>
                        <div class="text">
                          <p>
                            Provided you have consented, this website uses
                            Google Analytics, a web analytics service provided
                            by Google, Inc. (“Google”). For this purpose, a
                            cookie is installed on your computer. The
                            information generated by the cookie about your use
                            of the website (including your IP address) will be
                            transmitted to and stored by Google on servers in
                            the United States.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            We have activated the IP anonymization, this means
                            Google will truncate/anonymize the last octet of the
                            IP address for Member States of the European Union
                            as well as for other parties to the Agreement on the
                            European Economic Area. Only in exceptional cases,
                            the full IP address is sent to and shortened by
                            Google servers in the USA.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            On behalf of the website provider Google will use
                            this information for the purpose of evaluating your
                            use of the website, compiling reports on website
                            activity for website operators and providing other
                            services relating to website activity and internet
                            usage to the website provider. Google will not
                            associate your IP address with any other data held
                            by Google.
                          </p>
                        </div>
                        <div class="text">
                          <p><strong>Objection to data collection:</strong></p>
                          <p>
                            <strong
                              >You can also prevent Google’s collection and use
                              of data (cookies and IP address) by changing your
                              browser settings or by downloading and installing
                              the browser plug-in available under<a
                                class="hk-internal-link"
                                href="https://tools.google.com/dlpage/gaoptout?hl=en"
                                target="_blank"
                                rel="noopener"
                                data-webtrekkactionname="externalLinks"
                                >https://tools.google.com/dlpage/gaoptout?hl=en</a
                              ></strong
                            >
                          </p>
                        </div>
                      </div>
                      <div>
                        <div class="text">
                          <p><strong>Google DoubleClick</strong></p>
                        </div>
                        <div class="text">
                          <p>
                            Provided you have consented, we use the Google
                            DoubleClick function on our website in order to
                            evaluate the use of the website and make it possible
                            for us, Google and other advertisers who co-operate
                            with DoubleClick to be able to provide you with
                            user-relevant advertising. For this purpose, a
                            cookie is installed on your computer. This cookie
                            collects information on the advertising shown in
                            your browser and which advertisements you click. The
                            information generated by the cookie on your use of
                            website will be transferred to a Google server in
                            the US and stored there. Based on the information
                            collected, interest-related advertisements are being
                            displayed in your browser.
                          </p>
                        </div>
                        <div class="text">
                          <p><strong>Objection to data collection:</strong></p>
                          <p>
                            <strong
                              >You can also permanently deactivate the
                              DoubleClick cookie by changing your browser
                              settings or with the aid of a browser plug-in.
                              With the plug-in, your deactivation settings for
                              this browser are retained, even if you delete all
                              cookies. You can obtain the browser plug-in for
                              permanent deactivation<a
                                class="hk-internal-link"
                                href="https://support.google.com/ads/answer/7395996"
                                target="_blank"
                                rel="noopener"
                                data-webtrekkactionname="externalLinks"
                                >https://support.google.com/ads/answer/7395996</a
                              >.</strong
                            >
                          </p>
                        </div>
                      </div>
                      <div>
                        <div class="text">
                          <p><strong>Facebook Custom Audience Pixel</strong></p>
                        </div>
                        <div class="text">
                          <p>
                            We participate in Facebook's Custom Audience program
                            which - provided you have consented - enables us to
                            display personalized ads to you when you also have
                            subscribed to Facebook and log in into your Facebook
                            account. This tool allows us to personalize our ads
                            based on your usage of our website in order to
                            provide ads specifically tailored for you. To this
                            end we share your email address or phone number in a
                            hashed format which permits Facebook to identify you
                            in case you have also subscribed to Facebook.
                          </p>
                        </div>
                        <div class="text">
                          <p><strong>Objection to data collection:</strong></p>
                          <p>
                            <strong
                              >You can adjust your ad preferences by changing
                              your browser settings or through your Facebook
                              settings if you do not want to receive
                              interest-based ads on Facebook.</strong
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-box container-box--no-border">
          <div class="container-box__inner">
            <h2 class="row-headline row-headline--with-border">
              <span>Your Data Subject Rights / Data Protection Officer</span>
            </h2>
            <div class="row">
              <div
                class="col-tn-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 bab-stripe"
              >
                <div
                  class="standard-content"
                  data-wt-contenttype="HKStandardText"
                  data-wt-view="simple"
                >
                  <div>
                    <div class="extendedRichtext">
                      <div>
                        <div class="text">
                          <p>
                            At any time, you may assert the right to access your
                            data. Additionally, provided that the respective
                            requirements are met, you may assert the following
                            rights:
                          </p>
                        </div>
                        <div class="text">
                          <ul class="rte--list">
                            <li>Right to rectification</li>
                            <li>Right to erasure</li>
                            <li>Right to restriction of processing</li>
                            <li>
                              Right to lodge a complaint with the respectively
                              competent data protection supervisory authority
                            </li>
                            <li>
                              Right to data portability (as of May 25th 2018)
                            </li>
                          </ul>
                        </div>
                        <div class="text">
                          <p><strong>Right to object</strong></p>
                        </div>
                        <div class="text">
                          <p>
                            <strong
                              >In case of processing activities involving your
                              personal data that are carried out on basis of a
                              legitimate interest of Henkel, you have the right
                              to object against such processing of your personal
                              data at any time for reasons resulting from your
                              specific situation. Henkel will stop that
                              processing unless Henkel can prove important
                              reasons for the processing which deserve
                              protection which outweigh your interests, rights
                              and freedoms or if the processing serves to
                              assert, exercise or defend against legal
                              claims.</strong
                            >
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            如您已同意处理您的个人信息，您可随时撤销同意，将在日后生效。
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            我公司将在法律规定的期限内提供您的个人信息的复印件，但保留收取一定费用的权利以弥补自己的管理费用。请按以下地址致信给数据保护专员：<br />服务提供者：德国汉高股份有限及两合公司（汉高（中国）投资有限公司）<br />联系方式：<a
                              class="hk-internal-link"
                              href="mailto:dataprivacy.cn@henkel.com"
                              target="_blank"
                              rel="noopener"
                              data-webtrekkactionname="defaultLink"
                              >dataprivacy.cn@henkel.com</a
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-box container-box--no-border">
          <div class="container-box__inner">
            <h2 class="row-headline row-headline--with-border">
              <span>Use of Social Media Plug-ins</span>
            </h2>
            <div class="row">
              <div
                class="col-tn-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 bab-stripe"
              >
                <div
                  class="standard-content"
                  data-wt-contenttype="HKStandardText"
                  data-wt-view="simple"
                >
                  <div>
                    <div class="extendedRichtext">
                      <div>
                        <div class="text">
                          <p>
                            Plug-ins (“plug-ins”) of different social media
                            networks are embedded in our web pages. The
                            associated services are provided by the respective
                            companies (“providers”). These providers are:
                          </p>
                        </div>
                        <div class="text">
                          <ul class="rte--list">
                            <li>
                              Facebook is operated by Facebook Inc., 1601 S.
                              California Ave, Palo Alto, CA 94304, USA
                              ("Facebook"). For an overview of the Facebook
                              plug-ins and their appearance, go to:<a
                                href="https://developers.facebook.com/docs/plugins"
                                data-webtrekkactionname="externalLinks"
                                >https://developers.facebook.com/docs/plugins</a
                              >
                            </li>
                            <li>
                              Twitter is operated by Twitter Inc., 1355 Market
                              St, Suite 900, San Francisco, CA 94103, USA
                              (“Twitter”). For an overview of the Twitter
                              buttons and their appearance, go to:<a
                                href="https://twitter.com/about/resources/buttons"
                                data-webtrekkactionname="externalLinks"
                                >https://twitter.com/about/resources/buttons</a
                              >
                            </li>
                            <li>
                              Google+ and YouTube are provided by Google Inc.,
                              1600 Amphitheater Parkway, Mountainview,
                              California 94043, USA (“Google”). For an overview
                              of the Google+ plug-ins and their appearance, go
                              to:<a
                                href=" https://developers.google.com/+/web/"
                                data-webtrekkactionname="externalLinks"
                                >https://developers.google.com/+/web/</a
                              >; for the YouTube plugins, go to:<a
                                href="https://developers.google.com/youtube/subscribe/"
                                data-webtrekkactionname="externalLinks"
                                >https://developers.google.com/youtube/subscribe/</a
                              >
                            </li>
                            <li>
                              Instagram is provided by Instagram LLC., 1601
                              Willow Road, Menlo Park, CA 94025, USA
                              („Instagram“). For an overview of the Instagram
                              plug-ins and their appearance, go to:<a
                                href="http://blog.instagram.com/post/36222022872/"
                                data-webtrekkactionname="externalLinks"
                                >http://blog.instagram.com/post/36222022872/</a
                              >introducing-instagram-badges
                            </li>
                            <li>
                              LinkedIn is provided by LinkedIn Corporation, 2029
                              Stierlin Court, Mountain View, CA 94043, USA
                              (“LinkedIn”). For an overview of the LinkedIn
                              plug-ins and their appearance, go to:<a
                                href="https://developer.linkedin.com/plugins#"
                                data-webtrekkactionname="externalLinks"
                                >https://developer.linkedin.com/plugins#</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="text">
                          <p>
                            To increase the protection afforded to your data
                            when you visit our web pages, these plug-ins are
                            implemented as “2-click buttons.” This form of
                            integration ensures that, when accessing a page from
                            within our website containing such plug-ins, you are
                            not automatically connected to the providers’
                            servers. Only if you activate the plug-ins and
                            thereby permit for data transmission, the browser
                            will create a direct link to the providers’ servers.
                            The content of the various plug-ins is then
                            transmitted by the provider concerned directly to
                            your browser and then displayed on your screen.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            The plug-in tells the provider which of our website
                            pages you have accessed. If, while viewing our
                            website, you are logged into your user account with
                            the respective provider, he is able to collate your
                            interest, i.e. the information you are accessing,
                            with your user account. On making use of any of the
                            plug-in functions (e.g. clicking the “Like” button,
                            leaving a comment), this information too will be
                            transmitted by the browser directly to the provider
                            for retention.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            Further information on the collection and use of
                            data by the providers and on the rights and
                            possibilities available to you for protecting your
                            privacy in these circumstances can be found in the
                            providers’ data protection/privacy policies:
                          </p>
                        </div>
                        <div class="text">
                          <ul class="rte--list">
                            <li>
                              Data protection/privacy policy issued by
                              Facebook:<a
                                class="hk-internal-link"
                                href=" http://www.facebook.com/policy.php"
                                target="_blank"
                                rel="noopener"
                                data-webtrekkactionname="externalLinks"
                                >http://www.facebook.com/policy.php</a
                              >
                            </li>
                            <li>
                              Data protection/privacy policy issued by
                              Twitter:<a
                                class="hk-internal-link"
                                href=" https://twitter.com/privacy"
                                target="_blank"
                                rel="noopener"
                                data-webtrekkactionname="externalLinks"
                                >https://twitter.com/privacy</a
                              >
                            </li>
                            <li>
                              Data protection/privacy policy issued by Google:<a
                                href=" https://policies.google.com/privacy"
                                data-webtrekkactionname="externalLinks"
                                >https://policies.google.com/privacy</a
                              >
                            </li>
                            <li>
                              Data protection/privacy policy issued by
                              Instagram:<a
                                href="https://help.instagram.com/155833707900388/"
                                data-webtrekkactionname="externalLinks"
                                >https://help.instagram.com/155833707900388/</a
                              >
                            </li>
                            <li>
                              Data protection/privacy policy issued by
                              LinkedIn:<a
                                href=" https://www.linkedin.com/legal/privacy-policy"
                                data-webtrekkactionname="externalLinks"
                                >https://www.linkedin.com/legal/privacy-policy</a
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="diversity-overlay"></div>
      </main>
      <main v-if="language == 'cn'">
        <div class="container-box container-box--no-border">
          <div class="container-box__inner">
            <div class="row">
              <div
                class="col-tn-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 bab-stripe"
              >
                <div>
                  <div
                    data-wt-contenttype="HKStandardText"
                    data-wt-view="simple"
                    class="standard-content"
                  >
                    <div>
                      <div class="extendedRichtext"><h1>数据保护声明</h1></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-box container-box--no-border">
          <div class="container-box__inner">
            <h2 class="row-headline row-headline--with-border">
              <span>1. 总则</span>
            </h2>
            <div class="row">
              <div
                class="col-tn-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 bab-stripe"
              >
                <div
                  data-wt-contenttype="HKStandardText"
                  data-wt-view="simple"
                  class="standard-content"
                >
                  <div>
                    <div class="extendedRichtext">
                      <div>
                        <div class="text">
                          <p>
                            汉高（中国）投资有限公司，以下简称“汉高公司”或“我公司”）尊重浏览本网站人员的隐私权。我公司乐意告诉您关于我公司收集数据的类型和使用情况。您还将知晓如何行使数据主体的权利。
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            对本数据保护声明的任何变动都将在本页上公告。这将使得您能够随时获悉我们储存的数据和我们如何使用和收集这些数据。
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            本数据保护声明不适用于通过本网站的链接而进入的网站。
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-box container-box--no-border">
          <div class="container-box__inner">
            <h2 class="row-headline row-headline--with-border">
              <span> 2. 个人信息的收集、使用和处理</span>
            </h2>
            <div class="row">
              <div
                class="col-tn-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 bab-stripe"
              >
                <div
                  data-wt-contenttype="HKStandardText"
                  data-wt-view="simple"
                  class="standard-content"
                >
                  <div>
                    <div class="extendedRichtext">
                      <div>
                        <div class="text">
                          <p>责任实体名称：汉高（中国）投资有限公司</p>
                        </div>
                        <div class="text">
                          <p>
                            责任实体地址：上海市杨浦区江湾城路99号, 尚浦中心7幢,
                            200438,
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            汉高使用个人信息主要是为了向用户提供本网站，以及确保本网站的正常运行和安全。任何对信息的进一步处理仅在其他法定职责或许可的基础上进行，或在相关用户同意的情况下进行。
                          </p>
                        </div>
                        <div class="text">
                          <p>汉高专为以下目的存储和处理信息：</p>
                        </div>
                        <div class="text">
                          <p>
                            当用户访问网站时，汉高自动收集和存储某些信息。其中包括：分配给各个终端设备的IP地址或设备ID，以便我们传输所请求的内容（例如，特别是内容、文本、图像以及提供给下载的信息文件等）；网站场景下的用户活动；各终端设备的类型；使用的浏览器类型以及使用的日期和时间。
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            汉高将该等信息最多保存7天，用于识别和追究误用/滥用情况。
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            汉高还将该等信息用于改进服务的介绍、特性和功能，以及一般管理工作。
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            此外，汉高会删除或匿名化使用信息，包括IP地址。一旦该等信息不再需要用于上述目的，就会立即删除或匿名化。
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            处理及使用该等信息乃根据法定条文，以证明该等操作的合理性，原因如：（1）相关处理是提供本网站所必需的；或者（2）汉高在确保和加强网站的功能和无误操作，并根据用户的需要进行定制方面拥有至高无上的合法权益。
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            所收集的信息的接收方可包括：负责的内部部门成员、汉高的其他附属公司、外部服务提供商（例如托管和内容管理、营销机构、其他第三方提供商，如果他们提供的服务有必要）、行使各自职责和权力的部门，例如，当他们提出正式请求时，或如果有必要建立、行使或捍卫汉高的权利时，以及在发生交易（如出售、兼并或收购）时，汉高公司当前或未来的收购者。
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-box container-box--no-border">
          <div class="container-box__inner">
            <h2 class="row-headline row-headline--with-border">
              <span>3. 进一步处理个人信息</span>
            </h2>
            <div class="row">
              <div
                class="col-tn-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 bab-stripe"
              >
                <div
                  data-wt-contenttype="HKStandardText"
                  data-wt-view="simple"
                  class="standard-content"
                >
                  <div>
                    <div class="extendedRichtext">
                      <div>
                        <div class="text">
                          <p><strong>联系我司-联系方式</strong></p>
                        </div>
                        <div class="text">
                          <p>
                            您可能已通过“联系我司”的联系方式提供了您的联系资料。
                          </p>
                        </div>
                        <div class="text">
                          <p>我们将使用您提供的信息来回复您的请求。</p>
                        </div>
                        <div class="text">
                          <p>
                            处理和使用您的信息乃基于法定条文来证明操作的合理性，以判断是否有必要进行该等处理以处理您的请求。
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            如果您未同意延长存储期限，例如在利益相关者关系管理过程中，我们将以不超过为实现上述目的所需的时间存储信息，或在任何法定保留义务适用的情况下，视情况存储信息。
                          </p>
                        </div>
                      </div>
                      <div>
                        <div class="text">
                          <p><strong></strong></p>
                        </div>
                        <div class="text"><p></p></div>
                        <div class="text"><p></p></div>
                        <div class="text"><p></p></div>
                        <div class="text"><p></p></div>
                      </div>
                      <div>
                        <div class="text">
                          <p><strong></strong></p>
                        </div>
                        <div class="text"><p></p></div>
                        <div class="text"><p></p></div>
                        <div class="text"><p></p></div>
                        <div class="text"><p></p></div>
                      </div>
                      <div>
                        <div class="text">
                          <p><strong></strong></p>
                        </div>
                        <div class="text"><p></p></div>
                        <div class="text"><p></p></div>
                        <div class="text"><p></p></div>
                        <div class="text"><p></p></div>
                      </div>
                      <div>
                        <div class="text">
                          <p><strong></strong></p>
                        </div>
                        <div class="text"><p></p></div>
                        <div class="text"><p></p></div>
                        <div class="text"><p></p></div>
                        <div class="text"><p></p></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!---->
        <div class="container-box container-box--no-border">
          <div class="container-box__inner">
            <h2 class="row-headline row-headline--with-border">
              <span>4. Cookies、像素、指纹及类似技术</span>
            </h2>
            <div class="row">
              <div
                class="col-tn-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 multiple-elements-in-col bab-stripe"
              >
                <div
                  data-wt-contenttype="HKStandardText"
                  data-wt-view="simple"
                  class="standard-content"
                >
                  <div>
                    <div class="extendedRichtext">
                      <div>
                        <div class="text">
                          <p>
                            本网站使用cookies和类似技术。Cookies是由您的浏览器临时存储在您设备硬盘上的小数据单元，这是使用我们网站所必需的。cookie通常包含一个唯一的标识符，这是一个随机生成的数字，存储在您的设备上。有些在您的网站进程结束时即过期；有些则会在您的设备上停留更长的时间。技术上必要的cookies将被自动使用。其他cookies（或类似技术）将仅在您事先同意的基础上应用。
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            Cookies有不同类型。第一方cookies”是指所访问网站放置的cookies，仅供该网站读取。第三方是由我们用于各种服务的其他组织放置的cookies。例如我们使用代表我们放置的外部分析服务提供商告诉我们网站上被喜欢和不被喜欢的地方。此外，您访问的网站可能包含例如来自YouTube的嵌入内容，可能也会设置自己的cookies。
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            像素通常为不超过1像素x1像素的透明图像，放置在网站上用于收集IP地址、浏览器类型、访问时间等信息，或为了内容个性化或使浏览更高效、更方便而预先设置的cookies。当像素生成和管理cookies时，它们通常与cookies结合使用。
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            在您同意的情况下，本网站将收集有关设备操作系统、浏览器、语种、安装字体、IP地址、插件等信息，以便重新识别设备，达到用户相关的营销目的。
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            您可以在我们网站的<a
                              href="https://www.henkel.cn/cookies"
                              target="_self"
                              data-webtrekkactionname="defaultLink"
                              class="hk-internal-link"
                              >“Cookies”</a
                            >和<a
                              href="https://www.henkel.cn/cookies"
                              target="_self"
                              data-webtrekkactionname="defaultLink"
                              class="hk-internal-link"
                              >“Cookie设置”</a
                            >项下找到更多关于Cookies和我们网站使用的其他技术及其用途的信息。在那里，您还可以随时通过禁用相应的cookie设置来撤销您的同意，将在日后生效。
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion expand_0">
                  <div class="resp-tabs-container">
                    <h2
                      role="tab"
                      tabindex="0"
                      aria-controls="tab_item-0"
                      class="resp-accordion resp-accordion--mobile-headline"
                    >
                      <span class="resp-arrow"></span>
                      <div class="row">
                        <strong class="ones"
                          >a） Mapp Intelligence（原Webtrekk）</strong
                        >
                      </div>
                      <div class="selectchange"></div>
                    </h2>
                    <div class="accordion-wrapper resp-tab-content">
                      <div class="standard-content row">
                        <div
                          data-wt-contenttype="HKStandardText"
                          data-wt-view="simple"
                          class="standard-content"
                        >
                          <div>
                            <div class="extendedRichtext">
                              <div>
                                <div class="text">
                                  <p>
                                    如果您同意，本网站将使用在德国托管的Mapp
                                    Digital c/o Webtrekk GmbH（地址：Robert Koch
                                    Platz 4，10115
                                    Berlin，Germany）技术收集和存储信息，用于营销和优化目的。。为此，您的设备上安装了cookie。该cookie将收集浏览器和设备信息、您的IP地址、访问过的网站和访问时间等数据。这些数据存储在匿名或假名用户配置文件中，并根据匿名或假名用户配置文件进行进一步处理（取决于所采用的相应技术和服务）。这些用户配置文件存储在cookies或上面列出的其他类似技术中。除了在访问网站时收集的信息（如以上规定）以外，还可能包括您访问我们所使用的网址相关信息，您在访问我们期间访问的网址，以及适用时，您用于查找我们网站的任何搜索词。
                                  </p>
                                </div>
                                <div class="text">
                                  <p>
                                    未经用户的明确同意， 使用Mapp
                                    technologies收集的信息不得用于识别访客的个人身份，也不得与有关相应用户的任何其他个人信息相结合。<br />有关网络跟踪的进一步信息，请见我们供应商的数据保护政策：<br /><a
                                      href="https://mapp.com/privacy/&amp;nbsp;"
                                      target="_blank"
                                      rel="noopener"
                                      data-webtrekkactionname="externalLinks"
                                      class="hk-internal-link"
                                      >https://mapp.com/privacy/</a
                                    >
                                  </p>
                                </div>
                                <div class="text">
                                  <p>
                                    <strong
                                      >拒绝收集信息<br />您可以在“<a
                                        href="https://www.henkel.cn/cookies"
                                        target="_self"
                                        data-webtrekkactionname="defaultLink"
                                        class="hk-internal-link"
                                        >Cookie设置</a
                                      >”的“<a
                                        href="https://www.henkel.cn/cookies"
                                        target="_self"
                                        data-webtrekkactionname="defaultLink"
                                        class="hk-internal-link"
                                        >Cookies</a
                                      >”项下禁用我们网站上的cookies，随时撤销您的同意，将在日后生效。如果您同意在一般情况下使用cookies，但您不想使用Mapp
                                      Intelligence cookie，则您可以通过此<a
                                        href="https://mapp.com/opt-out-mapp/"
                                        target="_blank"
                                        rel="noopener"
                                        data-webtrekkactionname="externalLinks"
                                        class="hk-internal-link"
                                        >链接</a
                                      >设置退出cookie。根据浏览器和设备为命名域设置cookie。因此，如果您在家中、办公室或使用不同的浏览器访问我们网站，则您需要拒绝在每个设备或浏览器上存储信息</strong
                                    >
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h2
                      role="tab"
                      tabindex="0"
                      aria-controls="tab_item-1"
                      class="resp-accordion resp-accordion--mobile-headline"
                    >
                      <span class="resp-arrow"></span>
                      <div class="row">
                        <strong class="ones">b） 谷歌广告</strong>
                      </div>
                      <div class="selectchange"></div>
                    </h2>
                    <div
                      aria-labelledby="tab_item-1"
                      class="accordion-wrapper resp-tab-content"
                    >
                      <div class="standard-content row">
                        <div
                          data-wt-contenttype="HKStandardText"
                          data-wt-view="simple"
                          class="standard-content"
                        >
                          <div>
                            <div class="extendedRichtext">
                              <div>
                                <div class="text">
                                  <p>
                                    如果您同意，本网站将使用由谷歌爱尔兰有限公司，地址Gordon
                                    House, Barrow Street, Dublin 4, Ireland
                                    （以下简称“谷歌”）提供的“谷歌广告”服务，用于评估广告措施的效果，以及对您再次进行广告宣传。当您访问我们网站时，“谷歌广告”会在您的设备上安装cookie。通过该cookie，谷歌会处理您的设备生成的关于使用我们网站、与我们网站的交互和广告措施的信息、以及您的IP地址、浏览器信息、您之前访问过的网站和访问的日期和时间信息，以分析和可视化我们的广告达到测量和显示个性化广告的目的。为此，还可以判断不同的终端设备是属于您或您的家庭。通过“再营销”，我们网站的用户可以在谷歌广告网络内的其他网站（例如谷歌搜索或YouTube）上被重新识别，
                                    并向他们展示符合他们兴趣的广告。
                                  </p>
                                </div>
                                <div class="text">
                                  <p>
                                    Cookie生成的关于您使用本网站的信息（包括您的IP地址）将被传输并存储到谷歌在美国的服务器上根据欧洲法律，美国不保证提供充分的数据保护。由于大众监视法规，国家主管部门可能有权访问该等信息。一旦您的个人信息被披露，不享有同等程度的保障，您可能无法行使信息相关的权利。
                                  </p>
                                </div>
                                <div class="text">
                                  <p>
                                    通过允许在汉高网站上使用cookies，您同意谷歌使用上述信息和进行上述处理。
                                  </p>
                                </div>
                                <div class="text">
                                  <p>
                                    您可以在此处找到更多关于谷歌服务中隐私的信息：
                                  </p>
                                </div>
                                <div class="text">
                                  <p>
                                    <a
                                      href="https://www.google.de/intl/de/policies/privacy"
                                      target="_blank"
                                      rel="noopener"
                                      data-webtrekkactionname="externalLinks"
                                      class="hk-internal-link"
                                      >https://www.google.de/intl/de/policies/privacy</a
                                    >
                                  </p>
                                </div>
                                <div class="text">
                                  <p>
                                    <strong
                                      >拒绝收集信息：<br />您可以在“<a
                                        href="https://www.henkel.cn/cookies"
                                        target="_blank"
                                        rel="noopener"
                                        data-webtrekkactionname="defaultLink"
                                        class="hk-internal-link"
                                        >Cookie设置</a
                                      >”的“<a
                                        href="https://www.henkel.cn/cookies"
                                        target="_blank"
                                        rel="noopener"
                                        data-webtrekkactionname="defaultLink"
                                        class="hk-internal-link"
                                        >Cookies</a
                                      >”项下禁用我们网站上的cookies，随时撤销您的同意，将在日后生效。如果您同意在一般情况下使用cookies，但您不想收到个性化广告，则您可以通过此<a
                                        href="https://support.google.com/ads/answer/2662922?hl=en"
                                        target="_blank"
                                        rel="noopener"
                                        data-webtrekkactionname="externalLinks"
                                        class="hk-internal-link"
                                        >链接</a
                                      >找到如何修改谷歌广告设置的信息。您还可以安装一个<a
                                        href="https://support.google.com/ads/answer/7395996"
                                        target="_blank"
                                        rel="noopener"
                                        data-webtrekkactionname="externalLinks"
                                        class="hk-internal-link"
                                        >退出插件</a
                                      ></strong
                                    >
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h2
                      role="tab"
                      tabindex="0"
                      aria-controls="tab_item-2"
                      class="resp-accordion resp-accordion--mobile-headline"
                    >
                      <span class="resp-arrow"></span>
                      <div class="row">
                        <strong class="ones"
                          >c） 谷歌活动管理器360（原DoubleClick）</strong
                        >
                      </div>
                      <div class="selectchange"></div>
                    </h2>
                    <div
                      aria-labelledby="tab_item-2"
                      class="accordion-wrapper resp-tab-content"
                    >
                      <div class="standard-content row">
                        <div
                          data-wt-contenttype="HKStandardText"
                          data-wt-view="simple"
                          class="standard-content"
                        >
                          <div>
                            <div class="extendedRichtext">
                              <div>
                                <div class="text">
                                  <p>
                                    如果您同意，通过谷歌活动管理器360，我们将使用谷歌公司（Google
                                    LLC，地址1600 Amphitheatre Parkway, Mountain
                                    View, CA
                                    94043）提供的服务向您展示相关广告。为此，谷歌将使用您的IP地址在您的设备上安装cookie。除了IP地址、浏览器和设备信息、访问过的网站和访问时间之外，该cookie还收集有关在您的浏览器中显示的广告以及您点击了哪些广告的信息，以便谷歌及其合作站点根据您以前访问的汉高网页或其他网站显示兴趣相关的广告。活动管理器cookies利用分配给您的浏览器的假名识别号来检查屏幕上的和吸引您的广告。为此，当提供广告时，您的浏览器将被识别，并分配到一个目标群体。谷歌的cookies存储在您的设备上，从而允许您一方面（例如在“谷歌广告”的范围内）在谷歌的网站上被重新定位；另一方面（例如“谷歌活动管理器360”的范围内）在我们网站上，并根据您的兴趣，当您访问其他合作网站时重新定位。
                                  </p>
                                </div>
                                <div class="text">
                                  <p>
                                    该等信息还将用于评估您对本网站的使用、为网站运营商编制网站活动报告、以及提供与网站活动和互联网使用相关的其他服务。
                                  </p>
                                </div>
                                <div class="text">
                                  <p>
                                    谷歌可将您的信息用于任何自己的目的，如分析您的信息并将您的信息与其他（例如通过您的谷歌账号）收集到的关于您的信息关联起来。
                                  </p>
                                </div>
                                <div class="text">
                                  <p>
                                    Cookie生成的关于您使用本网站的信息将被传输到谷歌并存储在美国的服务器上。根据欧洲法律，美国不保证提供充分的数据保护。由于大众监视法规，国家主管部门可能有权访问该等信息。一旦您的个人信息被披露，不享有同等程度的保障，您可能无法行使信息相关的权利。
                                  </p>
                                </div>
                                <div class="text">
                                  <p>
                                    通过允许在汉高网站上使用cookies，您同意谷歌使用上述信息和进行上述处理。<br />您可以在此处找到更多关于谷歌服务中隐私的信息：
                                  </p>
                                </div>
                                <div class="text">
                                  <p>
                                    <a
                                      href="https://policies.google.com/privacy?hl=en"
                                      target="_blank"
                                      rel="noopener"
                                      data-webtrekkactionname="externalLinks"
                                      class="hk-internal-link"
                                      >http://www.google.de/intl/de/policies/privacy</a
                                    >
                                  </p>
                                </div>
                                <div class="text">
                                  <p>
                                    <strong
                                      >拒绝收集信息：<br />您可以在“<a
                                        href="https://www.henkel.cn/cookies"
                                        target="_self"
                                        data-webtrekkactionname="defaultLink"
                                        class="hk-internal-link"
                                        >Cookie设置</a
                                      >”的“<a
                                        href="https://www.henkel.cn/cookies"
                                        target="_self"
                                        data-webtrekkactionname="defaultLink"
                                        class="hk-internal-link"
                                        >Cookies</a
                                      >”项下禁用我们网站上的cookies，随时撤销您的同意，将在日后生效。如果您同意在一般情况下使用cookies，但您不想使用谷歌活动cookies，则您可以通过此<a
                                        href="https://www.google.com/settings/ads/onweb"
                                        target="_blank"
                                        rel="noopener"
                                        data-webtrekkactionname="externalLinks"
                                        class="hk-internal-link"
                                        >链接</a
                                      >停用谷歌活动管理器服务</strong
                                    >
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h2
                      role="tab"
                      tabindex="0"
                      aria-controls="tab_item-3"
                      class="resp-accordion resp-accordion--mobile-headline"
                    >
                      <span class="resp-arrow"></span>
                      <div class="row">
                        <strong class="ones colorshow">d） 社交媒体</strong>
                      </div>
                      <div class="selectchange selectchangeb"></div>
                    </h2>
                    <div
                      aria-labelledby="tab_item-3"
                      class="accordion-wrapper resp-tab-content shows"
                    >
                      <div class="standard-content row">
                        <div
                          data-wt-contenttype="HKStandardText"
                          data-wt-view="simple"
                          class="standard-content"
                        >
                          <div>
                            <div class="extendedRichtext">
                              <div>
                                <div class="text">
                                  <p>
                                    社交媒体内容管理服务，如各种社交媒体网络的cookies和插件被嵌入在我们网页上。只有在您同意后，相关服务才会由相关公司（“供应商”）提供。这些服务的目的是使您能够查看并与您的朋友和人际圈分享我们的内容。这些供应商有：
                                  </p>
                                </div>
                                <div class="text">
                                  <ul class="rte--list">
                                    <li>
                                      新浪微博由地址位于中国北京市海淀区海淀北二街10号7层的北京微梦创科网络技术有限公司运营（以下简称“微博”）。微博组件及其外观概览请访问：<a
                                        href="https://open.weibo.com/widgets/"
                                        target="_blank"
                                        rel="noopener"
                                        data-webtrekkactionname="externalLinks"
                                        class="hk-internal-link"
                                        >http://open.weibo.com/widgets/</a
                                      >
                                    </li>
                                    <li>
                                      腾讯微信由地址位于中国广东省深圳市南山区深南大道10000号腾讯大厦的腾讯公司运营（以下简称“微信”）。微信按钮及其外观概览请访问：<a
                                        href="https://weixin.qq.com/"
                                        target="_blank"
                                        rel="noopener"
                                        data-webtrekkactionname="externalLinks"
                                        class="hk-internal-link"
                                        >http://weixin.qq.com/</a
                                      >
                                    </li>
                                    <li>
                                      Facebook 的运营方为Facebook Inc., 1 Hacker
                                      Way, Menlo Park, CA 94025,
                                      USA；在欧盟的运营方为Facebook Ireland
                                      Limited, 4 Grand Canal Square, Dublin 2,
                                      Ireland
                                      （＂Facebook＂）Facebook插件及初次使用概览请访问：
                                      <a
                                        href="https://developers.facebook.com/docs/plugins"
                                        data-webtrekkactionname="externalLinks"
                                        >https://developers.facebook.com/docs/plugins</a
                                      >
                                    </li>
                                    <li>
                                      Twitter 的运营方为Twitter Inc., 1355
                                      Market St, Suite 900, San Francisco, CA
                                      94103, USA （“Twitter”）.
                                      Twitter按钮及外观概览请访问：
                                      <a
                                        href="https://developer.twitter.com/en/docs/twitter-for-websites"
                                        data-webtrekkactionname="externalLinks"
                                        >https://developer.twitter.com/en/docs/twitter-for-websites</a
                                      >
                                    </li>
                                    <li>
                                      YouTube的运营方为Google LLC, 1600
                                      Amphitheater Parkway, Mountainview,
                                      California 94043,
                                      USA；在欧盟的运营方为Google Ireland
                                      Limited, Gordon House, Barrow Street,
                                      Dublin 4, Ireland （“Google”）.
                                      YouTube插件概览请访问：
                                      <a
                                        href="https://developers.google.com/youtube/documentation"
                                        data-webtrekkactionname="externalLinks"
                                        >https://developers.google.com/youtube/documentation</a
                                      >
                                    </li>
                                    <li>
                                      Instagram的运营方为Facebook Ireland
                                      Limited, 4 Grand Canal Square, Dublin 2,
                                      Ireland （“Instagram”）.
                                      Instagram插件及初次使用概览请访问：
                                      <a
                                        href="https://developers.facebook.com/docs/instagram"
                                        data-webtrekkactionname="externalLinks"
                                        >https://developers.facebook.com/docs/instagram</a
                                      >
                                    </li>
                                    <li>
                                      领英的运营方为LinkedIn Corporation, 1000
                                      West Maude Avenue, Sunnyvale, California
                                      94085, USA；在欧盟的运营方为LinkedIn
                                      Ireland Unlimited Company, Gardner House,
                                      Wilton Plaza, Wilton Place, Dublin 2,
                                      Ireland
                                      （“LinkedIn”）LinkedIn插件及初次使用概览请访问：
                                      <a
                                        href="https://developer.linkedin.com/plugins"
                                        data-webtrekkactionname="externalLinks"
                                        >https://developer.linkedin.com/plugins#</a
                                      >
                                    </li>
                                  </ul>
                                </div>
                                <div class="text">
                                  <p>
                                    为了加强在您访问我们网页时的数据保护，
                                    这些社交媒体服务的执行均采用“双击按钮”。这种集成方式确保了当您通过含有这类插件的网页访问一个页面时，不会自动连接到供应商的服务器。只有当您激活社交媒体服务时，允许数据传输，浏览器才会创建一个直接链向供应商服务器的链接。随后由相应的供应商直接将各种插件内容传输到您的浏览器并在您的屏幕上播放。
                                  </p>
                                </div>
                                <div class="text">
                                  <p>
                                    插件会告知供应商您访问了我们的哪些网页。如果您在查看网站时登陆了您的微博或微信账号，供应商可以整理您的兴趣信息，即您的账号的访问信息。在您使用任何插件功能时（例如点击“喜欢”按钮、评论），这类信息也会通过浏览器被直接传输给供应商予以保留。
                                  </p>
                                </div>
                                <div class="text">
                                  <p>
                                    社交媒体工具会告诉供应商您以前访问过的网站、您的IP地址、浏览器信息以及服务器请求的日期和时间。在使用任何社交媒体功能时（例如点击“分享”按钮，留下评论），该等信息也会通过浏览器直接被直接传输给供应商予以保留。即使您没有登录您的社交媒体账号，供应商也可能将您的信息用于任何自己的目的，如分析、营销、配置以及将您的信息与其他（例如通过您在各供应商的用户账号）收集到的关于您的信息关联起来。
                                  </p>
                                </div>
                                <div class="text">
                                  <p>
                                    供应商处理信息的部分工作也在美国进行。根据欧洲法律，美国不保证提供充分的数据保护。由于大众监视法规，国家主管部门可能有权访问该等信息。一旦您的个人信息被披露，不享有同等程度的保障，您可能无法行使信息相关的权利。
                                  </p>
                                </div>
                                <div class="text">
                                  <p>
                                    通过允许在汉高网站上使用cookies，您同意供应商使用上述信息和进行上述处理。
                                  </p>
                                </div>
                                <div class="text">
                                  <p>
                                    更多关于微博或微信对数据的收集和使用，以及关于您在该等情况下的权利和隐私保护权的信息请见供应商发布的数据保护/隐私建议：
                                  </p>
                                </div>
                                <div class="text">
                                  <ul class="rte--list">
                                    <li>
                                      微博发布的数据保护/隐私建议：
                                      <a
                                        href="https://www.weibo.com/signup/v5/privacy"
                                        target="_blank"
                                        rel="noopener"
                                        data-webtrekkactionname="externalLinks"
                                        class="hk-internal-link"
                                        >http://www.weibo.com/signup/v5/privacy</a
                                      >
                                    </li>
                                    <li>
                                      微信发布的数据保护/隐私建议：
                                      <a
                                        href="https://www.qq.com/privacy.htm"
                                        target="_blank"
                                        rel="noopener"
                                        data-webtrekkactionname="externalLinks"
                                        class="hk-internal-link"
                                        >http://www.qq.com/privacy.htm</a
                                      >
                                    </li>
                                    <li>
                                      Data protection/privacy policy issued by
                                      Facebook:
                                      <a
                                        href="http://www.facebook.com/policy.php"
                                        data-webtrekkactionname="externalLinks"
                                        >http://www.facebook.com/policy.php</a
                                      >
                                    </li>
                                    <li>
                                      Data protection/privacy policy issued by
                                      Facebook:
                                      <a
                                        href="https://twitter.com/en/privacy"
                                        data-webtrekkactionname="externalLinks"
                                        >https://twitter.com/en/privacy</a
                                      >
                                    </li>
                                    <li>
                                      Data protection/privacy policy issued by
                                      Google:
                                      <a
                                        href="https://policies.google.com/privacy"
                                        data-webtrekkactionname="externalLinks"
                                        >https://policies.google.com/privacy</a
                                      >
                                    </li>
                                    <li>
                                      Data protection/privacy policy issued by
                                      Instagram:
                                      <a
                                        href="https://help.instagram.com/155833707900388/"
                                        data-webtrekkactionname="externalLinks"
                                        >https://help.instagram.com/155833707900388/</a
                                      >
                                    </li>
                                    <li>
                                      Data protection/privacy policy issued by
                                      LinkedIn:
                                      <a
                                        href="https://www.linkedin.com/legal/privacy-policy"
                                        data-webtrekkactionname="externalLinks"
                                        >https://www.linkedin.com/legal/privacy-policy</a
                                      >
                                    </li>
                                  </ul>
                                </div>
                                <div class="text">
                                  <p>
                                    为避免允许微博或微信将您的网站访问链接至您在这些供应商的账号，您需要在访问我们的网页前退出您的相应的账号。
                                  </p>
                                </div>
                                <div class="text">
                                  <p>
                                    <strong
                                      >拒绝收集信息：<br />您可以在“<a
                                        href="https://www.henkel.cn/cookies"
                                        target="_blank"
                                        rel="noopener"
                                        data-webtrekkactionname="defaultLink"
                                        class="hk-internal-link"
                                        >Cookie设置</a
                                      >”的“<a
                                        href="https://www.henkel.cn/cookies"
                                        target="_blank"
                                        rel="noopener"
                                        data-webtrekkactionname="defaultLink"
                                        class="hk-internal-link"
                                        >Cookies</a
                                      >”项下禁用我们网站上的cookies，随时撤销您的同意，将在日后生效。您还可以通过修改浏览器设置或社交媒体平台设置来修改您的喜好。</strong
                                    >
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
        <!---->
        <div class="container-box container-box--no-border">
          <div class="container-box__inner">
            <h2 class="row-headline row-headline--with-border">
              <span> 5. 数据主体权利/数据保护专员</span>
            </h2>
            <div class="row">
              <div
                class="col-tn-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 bab-stripe"
              >
                <div
                  data-wt-contenttype="HKStandardText"
                  data-wt-view="simple"
                  class="standard-content"
                >
                  <div>
                    <div class="extendedRichtext">
                      <div>
                        <div class="text">
                          <p>
                            在任何时候，您都有权访问您的信息。此外如果符合相应要求，您还可以主张以下权利：
                          </p>
                        </div>
                        <div class="text">
                          <ul class="rte--list">
                            <li>更正权</li>
                            <li>删除权</li>
                            <li>限制处理权</li>
                            <li>有权向各数据保护主管部门投诉</li>
                            <li>数据携带权（2018年5月25日起）</li>
                          </ul>
                        </div>
                        <div class="text">
                          <p><strong>反对权</strong></p>
                        </div>
                        <div class="text">
                          <p>
                            <strong
                              >如果涉及您的个人信息的操作活动是基于汉高的合法利益进行的，您有权在任何时候以您的特定情况为理由反对此类操作。汉高将停止该操作，除非能够证明此操作值得保护的重要理由，该理由超过您的利益、权利和自由，或该操作用于主张、行使或抗辩法律索赔。</strong
                            >
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            如您已同意处理您的个人信息，您可随时撤销同意，将在日后生效。
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            在这种情况下，或者您有一些关于您个人信息的其他愿望，请给我们的数据保护专员发电子邮件[<a
                              href="mailto:dataprivacy.cn@henkel.com"
                              target="_blank"
                              rel="noopener"
                              data-webtrekkactionname="defaultLink"
                              class="hk-internal-link"
                              >dataprivacy.cn@henkel.com</a
                            >.
                          </p>
                        </div>
                        <div class="text">
                          <p>
                            我公司将在法律规定的期限内提供您的个人信息的复印件，但保留收取一定费用的权利以弥补自己的管理费用。请按以下地址致信给数据保护专员：<br />服务提供者：德国汉高股份有限及两合公司（汉高（中国）投资有限公司）<br />联系方式：<a
                              href="mailto:dataprivacy.cn@henkel.com"
                              target="_blank"
                              rel="noopener"
                              data-webtrekkactionname="defaultLink"
                              class="hk-internal-link"
                              >dataprivacy.cn@henkel.com</a
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!---->
        <div class="diversity-overlay"></div>
      </main>
    </div>
  </div>
</template>
<script>
import { uiHelper } from "@/core/utils";

export default {
  name: "Imprint",
  data: () => ({}),
  computed: {
    language() {
      return uiHelper.getLocalStorage("language");
    },
  },
};
</script>
<style lang="scss">
.data-protection-statement {
  .accordion .resp-tab-content {
    padding: 32px 0 24px;
    border-bottom: 2px solid #000;
  }

  .shows {
    display: block !important;
  }

  .bordershow {
    border-color: #e1000f !important;
  }

  .colorshow {
    color: #e1000f;
  }

  .accordion-wrapper {
    margin-top: 10px;
  }

  * {
    margin: 0;
    padding: 0;
  }

  *,
  :after,
  :before {
    box-sizing: border-box;
  }

  .extendedRichtext {
    width: 87%;
  }

  .all {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-top: 60px;
    font-size: 10px;
    color: #000;
    font-family: Segoe UI, Helvetica, sans-serif;
    background-color: #fff;
    position: relative;
    min-height: 100%;
  }

  main {
    width: 70%;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    line-height: 1.428571429;
    font-size: 10px;
    color: #000;
    font-family: Segoe UI, Helvetica, sans-serif;
    box-sizing: border-box;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 0;
    margin-bottom: 100px;
  }

  .fixed-footer {
    position: absolute;
    bottom: 0px;
    right: 0px;
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .container-box {
    width: 100%;
  }

  .standard-content h1,
  h1 {
    font-weight: 300;
  }

  .ones {
    font-weight: 400;
  }

  .standard-content .h1-like-headline,
  .standard-content h1 {
    font-size: 4.8rem;
    color: #e1000f;
    float: left;
    padding: 0 0 0.75em;
    width: 100%;
    word-wrap: break-word;
  }

  ul.rte--list {
    list-style-type: square;
    margin-left: 0;
    margin-bottom: 4em;
  }

  .rte--list li,
  .text > ol li,
  .text > ul li {
    width: 100%;
    font-size: 1.4rem;
    line-height: 1.6em;
    list-style-position: outside;
  }

  h1 {
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    box-sizing: border-box;
    font-family: inherit;
    line-height: 1.3;
    margin: 0;
    font-size: 4.8rem;
    color: #e1000f;
    float: left;
    padding: 0 0 0.75em;
    width: 100%;
    word-wrap: break-word;
    font-weight: 300;
  }

  .container-box--no-border:not(.stage-full) {
    margin-bottom: 2rem;
  }

  .row-headline--with-border {
    padding-bottom: 1.3rem;
    border-bottom: 2px solid #000;
  }

  .row-headline {
    width: 100%;
    font-size: 2.4rem;
    margin-top: 1rem;
    margin-bottom: 2rem;
    font-weight: 400;
  }

  p {
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    line-height: 1.428571429;
    color: #000;
    font-family: Segoe UI, Helvetica, sans-serif;
    box-sizing: border-box;
    padding: 0;
    font-size: 1.4rem;
    margin: 0 0 1.5em;
    max-width: 100%;
  }

  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12,
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12,
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12,
  .col-tn-1,
  .col-tn-2,
  .col-tn-3,
  .col-tn-4,
  .col-tn-5,
  .col-tn-6,
  .col-tn-7,
  .col-tn-8,
  .col-tn-9,
  .col-tn-10,
  .col-tn-11,
  .col-tn-12,
  .col-xs-1,
  .col-xs-2,
  .col-xs-3,
  .col-xs-4,
  .col-xs-5,
  .col-xs-6,
  .col-xs-7,
  .col-xs-8,
  .col-xs-9,
  .col-xs-10,
  .col-xs-11,
  .col-xs-12 {
    position: relative;
    min-height: 1px;
    padding-left: 4px;
    padding-right: 4px;
  }

  .standard-content .text a:not(.link-element) {
    text-decoration: underline;
  }

  li {
    display: list-item;
    text-align: -webkit-match-parent;
  }

  b,
  strong {
    font-weight: 600;
  }

  .resp-tabs-container {
    width: 100%;
  }

  .resp-accordion {
    width: 100% !important;
    display: block;
    padding: 16px 0;
    margin: 0;
    cursor: pointer;
    position: relative;
    border-bottom: 2px solid #000;
    padding-right: 3.5rem;
  }

  .row {
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    line-height: 1.428571429;
    font-size: 2.4rem;
    color: #000;
    font-family: Segoe UI, Helvetica, sans-serif;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    margin-left: -4px;
    margin-right: -4px;
    font-weight: 400;
  }

  .row:focus {
    color: #e1000f;
    border-color: #e1000f;
  }

  ul {
    list-style-type: disc;
  }

  *,
  :after,
  :before {
    box-sizing: border-box;
  }

  *,
  :after,
  :before {
    box-sizing: border-box;
  }

  *,
  :after,
  :before {
    box-sizing: border-box;
  }

  h2 {
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    box-sizing: border-box;
    font-family: inherit;
    line-height: 1.3;
    font-weight: 400;
    display: block;
    padding: 16px 0;
    margin: 0;
    cursor: pointer;
    position: relative;
    border-bottom: 2px solid #000;
    padding-right: 3.5rem;
    font-size: 2.4rem;
    margin-bottom: 10px;
  }

  a {
    -webkit-text-size-adjust: 100%;
    line-height: 1.428571429;
    font-family: Segoe UI, Helvetica, sans-serif;
    font-size: 1.6rem;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    background-color: transparent;
    border: none;
    color: #000;
    -webkit-tap-highlight-color: transparent;
    display: inline;
    word-break: break-word;
    text-decoration: underline;
  }

  a:focus,
  a:hover {
    color: #e1000f;
    text-decoration: none;
  }
}
</style>
